import RestService from './RestService';
import dateFormat from 'dateformat';

async function query(query) {
    const res = await RestService.performRestOpNext(`gsc/query`, query);
    console.log(res);
    return res;
}

async function getNewKeywordsOfPage({ domain, page, ck1 = -90, ck2 = -9, ck3 = -2, addedImpressionsThreshold = 0, lostImpressionsThreshold = 10 }) {
    const oldRes = await query({
        siteUrl: `sc-domain:${domain}`,
        requestBody: {
            startDate: getDateAsString(ck1),
            endDate: getDateAsString(ck2 - 1),
            dimensions: ['query'],
            dimensionFilterGroups: [
                {
                    "filters": [
                        {
                            "dimension": 'page',
                            "operator": 'contains',
                            "expression": page
                        }
                    ]
                }
            ]
        }
    });

    const newRes = await query({
        siteUrl: `sc-domain:${domain}`,
        requestBody: {
            startDate: getDateAsString(ck2),
            endDate: getDateAsString(ck3),
            dimensions: ['query'],
            dimensionFilterGroups: [
                {
                    "filters": [
                        {
                            "dimension": 'page',
                            "operator": 'contains',
                            "expression": page
                        }
                    ]
                }
            ]
        }
    });

    console.log(oldRes)

    const oldKeywords = oldRes.rows.map(c => ({ keyword: c.keys[0], impressions: c.impressions, clicks: c.clicks, ctr: c.ctr, position: c.position }))
    const newKeywords = newRes.rows.map(c => ({ keyword: c.keys[0], impressions: c.impressions, clicks: c.clicks, ctr: c.ctr, position: c.position }))
    const added = newKeywords.filter(x => !oldKeywords.find(y => x.keyword === y.keyword)).reduce((acc, current) => {
        if (current.impressions > addedImpressionsThreshold) acc.push(current);
        return acc;
    }, []);
    const lost = oldKeywords.filter(x => !newKeywords.find(y => x.keyword === y.keyword)).reduce((acc, current) => {
        if (current.impressions > lostImpressionsThreshold) acc.push(current);
        return acc;
    }, []);

    return { lostKws: lost, addedKws: added, currentKeywords: newKeywords };

}

async function getPageDetails({ domain, page, ck1 = -90, ck2 = -2 }) {
    const request = {
        siteUrl: `sc-domain:${domain}`,
        requestBody: {
            startDate: getDateAsString(ck1),
            endDate: getDateAsString(ck2),
            dimensions: ['page'],
            dimensionFilterGroups: [
                {
                    "filters": [
                        {
                            "dimension": 'page',
                            "operator": 'contains',
                            "expression": page
                        }
                    ]
                }
            ]
        }
    };
    console.log(request);

    const data = await query(request);
    return data.rows
}

const getDateAsString = (difference, format = "yyyy-mm-dd") => {
    const d = new Date();
    d.setDate(d.getDate() + difference);
    return dateFormat(d, format);
}


export default {
    query,
    getNewKeywordsOfPage,
    getPageDetails,
    getDateAsString
}